<div
  class="chat-dialog-footer"
  role="group"
  [attr.aria-label]="'chat-bot.window.input-group-aria-label' | translate">
  <button
    class="chat-dialog-footer__clean-button no-style"
    [attr.aria-label]="'chat-bot.actions.restart-chat' | translate"
    [disabled]="isRestartDisabled()"
    (click)="restartChat.emit()">
    <mat-icon>delete_sweep</mat-icon>
  </button>
  <div class="chat-dialog-footer__textarea-container">
    <textarea
      #textarea
      class="chat-dialog-footer__textarea"
      [attr.aria-label]="'chat-bot.window.input-aria-label' | translate"
      [attr.placeholder]="'chat-bot.window.input-placeholder' | translate"
      [rows]="1"
      [(ngModel)]="message"
      (keydown)="handleTextareaKeydown($event)"></textarea>
  </div>
  <button
    class="chat-dialog-footer__send-button no-style"
    [attr.aria-label]="'chat-bot.actions.send-message' | translate"
    [disabled]="isSendButtonDisabled()"
    (click)="handleSendMessage()">
    <mat-icon>send</mat-icon>
  </button>
</div>
<p class="chat-dialog-footer__notice">{{ footNote() | translate }}</p>
